import axios, { AxiosError } from 'axios';
import { Api } from '../axiosApi';

export interface IOrdemServicoHistorico {
  idhistorico: string;
  idos: string;
  tipo: string;
  statusanterior?: string;
  statusnovo?: string;
  descricao?: string;
  iduser: string;
  criadoem: string;
}

interface ErrorResponse {
  errors: {
    default: string;
  };
}

const getAllByOs = async (idos: string): Promise<IOrdemServicoHistorico[] | Error> => {
  try {
    const { data } = await Api.get(`/ordemservico/${idos}/historico`);
    if (data) return data;
    return new Error('Erro ao consultar o histórico.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        return new Error(axiosError.response.data.errors?.default || 'Erro desconhecido');
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    }
    return new Error('Erro inesperado');
  }
};

export const OrdemServicoHistoricoService = {
  getAllByOs,
};
